import { CircularProgress, FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { observer } from "mobx-react-lite";
import { useStore } from "../../app/stores/store";

function RBDSettingStation() {
    const { commonStore, rbdStore } = useStore();

    return (
        <FormControl fullWidth sx={{ mb: 4 }}>
            <InputLabel id="stationLabel">Station</InputLabel>
            <Select
                labelId="stationLabel"
                value={rbdStore.selectedStation?.id ?? 0}
                label="Station"
                disabled
                endAdornment={(
                    <>
                        {commonStore.loadingStation ? <CircularProgress color="inherit" size={20} sx={{mr: 2.5}} /> : null}
                    </>
                )}
            >
                <MenuItem value={rbdStore.selectedStation?.id ?? 0}>{rbdStore.selectedStation?.name}</MenuItem>
            </Select>
        </FormControl>
    );
}

export default observer(RBDSettingStation);